// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ErrorComponent = ({ error }: { error: any }) => {
  return <h6>An Error Occurred: {error.errorCode}</h6>;
};
